import { createReducer } from 'deox';
import { produce } from 'immer';

import { buySubscription, updateSubscription, deleteSubscription, clearError, showCancelPopup } from './actions';
import { SubscriptionTypes } from './types';

const initialState: SubscriptionTypes = {
  loading: false,
  errors: {},
  account_info: {
    clinic_name: '',
    email: '',
    full_name: '',
    phone_number: '',
    position_title: '',
  },
  plan: {
    expiry_date: '',
    is_active: false,
    name: '',
    number_of_machines: 0,
    price: '',
    start_date: '',
  },
  billing_history: [],
  machines: [],
  isCancelPopup: false,
};

export const subscriptionReducer = createReducer(initialState, handleAction => [
  // GET BUY SUBSCRIPTION
  handleAction(buySubscription.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(buySubscription.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(buySubscription.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // UPDATE SUBSCRIPTION
  handleAction(updateSubscription.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(updateSubscription.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(updateSubscription.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // UPDATE SUBSCRIPTION
  handleAction(deleteSubscription.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(deleteSubscription.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(deleteSubscription.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  handleAction(showCancelPopup, (state, { payload }) =>
    produce(state, draft => {
      draft.isCancelPopup = payload;
    }),
  ),
  handleAction(clearError, state =>
    produce(state, draft => {
      draft.errors = {};
    }),
  ),
]);
